const CountryCodes = {
  REGULAR_REGION_CODES: ['AU', 'NZ'],
};

export default CountryCodes;
